module.exports = __webpack_public_path__ + "static/media/share-mobile.6af51c04.png";